const menuData = [
    {
        "header": "MAIN MENU",
        "items": [
            {
                "text": "Dashboard",
                "icon": "bx bx-home",
                "available": true,
                "link": "/dashboard"
            },
            {
                "text": "Bookings",
                "icon": "bx bx-calendar-check",
                "available": true,
                "link": "/bookings"
            },
            {
                "text": "Booking Transactions",
                "icon": "bx bx-receipt",
                "available": true,
                "link": "/payment-transactions"
            },
            {
                "text": "Commissions",
                "icon": "bx bx-money",
                "available": true,
                "link": "/commissions"
            },
            {
                "text": "Payouts",
                "icon": "bx bx-wallet",
                "available": true,
                "link": "/payouts"
            },
            /*{
                "text": "Car Brands",
                "icon": "bx bx-car",
                "available": true,
                "link": "/car-brands"
            },
            {
                "text": "Car Models",
                "icon": "bx bx-car",
                "available": true,
                "link": "/car-models"
            },*/
            {
                "text": "Customers",
                "icon": "bx bx-user",
                "available": true,
                "link": "/customers"
            },
            {
                "text": "Washers",
                "icon": "bx bx-user-plus",
                "available": true,
                "link": "/washers"
            },
            {
                "text": "Vouchers",
                "icon": "bx bx-credit-card",
                "available": true,
                "link": "/vouchers"
            },            
        ]
    },
    {
        "header": "SERVICES",
        "items": [
            {
                "text": "Service Categories",
                "icon": "bx bx-category",
                "available": true,
                "link": "/services/categories"
            },
            {
                "text": "Services",
                "icon": "bx bx-list-ul",
                "available": true,
                "link": "/services"
            },
            {
                "text": "Addon Services",
                "icon": "bx bx-plus",
                "available": true,
                "link": "/addon-services"
            },
            {
                "text": "Cleaning Equipment",
                "icon": "bx bx-brush",
                "available": true,
                "link": "/cleaning-equipment"
            },
            {
                "text": "Customer Requirements",
                "icon": "bx bx-check-shield",
                "available": true,
                "link": "/customer-requirements"
            }
        ]
    },
    {
        "header": "REPORTS",
        "items": [
            {
                "text": "Sales & Revenue",
                "icon": "bx bx-category",
                "available": true,
                "link": "/reports/sales-revenue"
            },
            {
                "text": "Service Performance",
                "icon": "bx bx-list-ul",
                "available": true,
                "link": "/reports/service-performance"
            },
            {
                "text": "Customer Feedback & Ratings Summary",
                "icon": "bx bx-plus",
                "available": true,
                "link": "/reports/customer-feedback"
            },
            {
                "text": "Customer Report",
                "icon": "bx bx-brush",
                "available": true,
                "link": "/reports/customer-reports"
            },
            {
                "text": "Staff / Employee Report",
                "icon": "bx bx-check-shield",
                "available": true,
                "link": "/reports/staff"
            }
        ]
    },
    {
        "header": "SETTINGS",
        "items": [
            {
                "text": "Settings",
                "icon": "bx bx-cog",
                "available": true,
                "link": "/settings",
                "submenu": [
                    {
                        "text": "General Settings",
                        "available": true,
                        "link": "/settings/general"
                    },
                    {
                        "text": "Business Hours",
                        "available": true,
                        "link": "/settings/business-hours"
                    },
                    {
                        "text": "Payment Methods",
                        "available": true,
                        "link": "/settings/payment-methods"
                    }
                ]
            }
        ]
    },
    {
        "header": "USER MANAGEMENT",
        "items": [
            {
                "text": "User Management",
                "icon": "bx bx-user-circle",
                "available": true,
                "link": "/admin-management",
            }
        ]
    },
    {
        "header": "CONTENT MANAGEMENT",
        "items": [
            {
                "text": "FAQs",
                "icon": "bx bx-help-circle",
                "available": true,
                "link": "/faqs"
            },
            {
                "text": "Cancellation Policies",
                "icon": "bx bx-time",
                "available": true,
                "link": "/cancellation-policies"
            },
            {
                "text": "Banners",
                "icon": "bx bx-image",
                "available": true,
                "link": "/banners"
            },
            /*{
                "text": "Pages",
                "icon": "bx bx-image",
                "available": true,
                "link": "/pages"
            }*/
        ]
    },
    /*{
        "header": "ACCOUNT",
        "items": [
            {
                text: "Logout",
                icon: "bx bx-power-off",
                action: "logout"
            }
        ]
    }*/
    
    /*{
        "header": "USER MANAGEMENT",
        "items": [
            {
                "text": "User Management",
                "icon": "bx bx-user-circle",
                "available": true,
                "link": "#",
                "submenu": [
                    {
                        "text": "Profile",
                        "available": true,
                        "link": "/profile"
                    },
                    {
                        "text": "Admin Management",
                        "available": true,
                        "link": "/admin-management"
                    },
                    {
                        "text": "Users",
                        "available": true,
                        "link": "/users"
                    },
                    {
                        "text": "Roles & Permissions",
                        "available": true,
                        "link": "/roles"
                    },
                    {
                        "text": "Logout",
                        "icon": "bx bx-log-out",
                        "available": true,
                        "link": "/logout"
                    }
                ]
            }
        ]
    }*/
];

export default menuData;
